import React, { useState } from 'react';
import { render } from 'react-dom';
import './Login.css';
import Base from '../base/Base.js';
import {apisettigs} from '../../../src/settings.js';


function Login() {
    const [eMsg, setMsg] = useState('');

    const [msgContClas, setmsgContClas] = useState('d-flex infocont justify-content-between d-none');

    let inputUser = React.createRef();
    let inputPass = React.createRef();
    
    
    function getCookie(cookieName) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
          let [key,value] = el.split('=');
          cookie[key.trim()] = value;
        })
        return cookie[cookieName];
    } 


    let cookie_dsp_mbl = getCookie('dspmobil');


    async function onClickHandler() {
        let usr = inputUser.current.value.trim();
        let pss = inputPass.current.value.trim();

        if (usr.length <= 0) {
            setMsg('Usuário Inválido');
            setmsgContClas('d-flex infocont justify-content-between');
        }
        else if (pss.length <= 0) {
            setMsg('Senha Inválida');
            setmsgContClas('d-flex infocont justify-content-between');
        }
        else {
            // Post to api
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ username: usr, password: pss })
            };
            
           
            const response = await fetch(apisettigs.endpoints.getauth, requestOptions);

            const data = await response.json();

            //console.log(data.msg);
            switch (data.auth) {
                case 'fail':
                    setMsg(data.msg);
                    setmsgContClas('d-flex infocont justify-content-between');
                    break;
                case 'ok':
                    setMsg('');
                    setmsgContClas('d-flex infocont justify-content-between d-none');
                    //console.log(data.user_id, data.auth, data.token);
                    //console.log('token - ', atob(data.token));
                    window.sessionStorage.setItem("userId", data.user_id);
                    window.sessionStorage.setItem("token", data.token);
                    return render(<Base />, document.getElementById('root'));
                default:
                    setMsg('');
                    setmsgContClas('d-flex infocont justify-content-between d-none');
            }
        }
    };


    function redir(){
        document.cookie = 'dspmobil=desk;path=/';
        window.location.href = apisettigs.serverUrl;
    }

    return (
        <div className='container-fluid'>

            <div className="container loginTitle mt-4 text-center">
                Portal de Compras
            </div>

            <div className="container loginCont">

                <div className="container loginBox">

                    <div className="card loginCard" style={{ maxWidth: '18rem' }}>
                        <div className="card-body" style={{ paddingTop: '2rem' }}>

                            <div className="login-input-container" style={{ marginbottom: '2.5rem' }}>
                                <div className="inner-addon right-addon">
                                    <i className="fas fa-user"></i>
                                    <input type="text" autoComplete="off" required="" name="username" ref={inputUser} />
                                    <label>Usuário</label>
                                </div>
                            </div>
                            <div className="login-input-container">
                                <div className="inner-addon right-addon">
                                    <i className="fas fa-lock"></i>
                                    <input type="password" required="" name="userpasswd" ref={inputPass} />
                                    <label>Senha</label>
                                </div>
                            </div>
                            <div className="container text-center">
                                <button className="btn btn-outline-primary loginButton" onClick={onClickHandler}>
                                    Login
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className={msgContClas}>
                        <div className="d-flex" style={{ width: '1rem' }}></div>
                        <div className="align-self-center">
                            <span className="mmsg">
                                {eMsg}
                            </span>
                        </div>
                        <div className="align-self-center" style={{ width: '2rem' }}>
                            <span className="mmsgfa">
                                <i className="fas fa-exclamation-triangle"></i>
                            </span>
                        </div>
                    </div>

                </div>

            </div>

            <div className="container text-center mt-5 mb-4" style={{ maxWidth: '18rem' }}>
                <img src="https://portalcompras.hebraica.org.br/static/images/hbr_logo.png" alt="" height="auto" width="60%" />
            </div>

            <div className="container text-center mb-4">
                <a onClick={redir} style={{color:'#0d6efd', textDecoration:'underline'}} >Versão Desktop</a>
            </div>

        </div>
    )
}

export default Login;